import request from '../request'

/**
 * 设计服务报告相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function addDesignService(data) {
    return request({
        url: '/project-service/cosys/design/service/add',
        method: 'POST',
        data
    })
}

export function fetchDesignServiceDetail(id) {
    return request({
        url: `/project-service/cosys/design/service/detail/${id}`,
        method: 'GET'
    })
}

export function fetchDesignServiceList(params) {
    return request({
        url: '/project-service/cosys/design/service/list',
        method: 'GET',
        params
    })
}

export function updateDesignService(data) {
    return request({
        url: '/project-service/cosys/design/service/update',
        method: 'POST',
        data
    })
}

export function exportDesignService(id) {
    return request({
        url: `/project-service/cosys/design/service/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}

export function resubmitDesignService(data) {
    return request({
        url: '/project-service/cosys/design/service/resubmit',
        method: 'POST',
        data
    })
}
